import { render, staticRenderFns } from "./UnPaidTransaction.vue?vue&type=template&id=15539522&"
import script from "./UnPaidTransaction.vue?vue&type=script&lang=js&"
export * from "./UnPaidTransaction.vue?vue&type=script&lang=js&"
import style0 from "./UnPaidTransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports